<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_v"></a>To my father,<br/><em>who taught me to see the world<br/>through a hero’s eyes</em></p>
<p class="dedication">And my mother,<br/><em>who encouraged me to act like a hero<br/>no matter the obstacles<a id="page_vi"></a></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch0005_dedi.vue?62a70e73